import React from "react";
import "../styles/LandingPage.css";
import backgroundImage from "../assets/landingpageImage.png";

const LandingPage = () => {
  return (
    <div
      className="main-content1"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="background-overlay"></div>
      <div className="content-overlay">
        <h2 className="main-heading">
          Imagine AI Art <br />
          Generator
        </h2>
        <p className="main-paragraph">
          Revolutionize your creative process with our generative
          AI-content-creation products. Seamlessly <br />
          turn ideas into stunning content, effortlessly pushing the boundaries
          of what's possible. Elevate
          <br />
          your work and embrace a future where innovation meets simplicity.{" "}
          <br />
          Welcome to a new era of content creation.
        </p>
      </div>
    </div>
  );
};

export default LandingPage;
